<li class="flex py-1 w-full">
    <div
        class="truncate w-full cursor-pointer"
        (click)="toggleFilterSelection.emit(filter())">
        <app-checkbox [checkboxState]="checkboxState()" />
        <span class="flex-1 pl-1 overflow-x-hidden text-ellipsis whitespace-nowrap">{{ filter().name }}</span>
    </div>
    <button
        class="bg-transparent border-none edit-button pl-2"
        [class.is-disabled]="!mapFilterPermissionsService.canManage()"
        [matTooltip]="mapFilterPermissionsService.tooltipInsufficient() | transloco"
        [matTooltipDisabled]="mapFilterPermissionsService.canManage()"
        (click)="editClicked($event)">
        <fa-icon [icon]="['fas', 'pen']" />
    </button>
    <button
        class="bg-transparent border-none delete-button pl-2"
        [class.is-disabled]="!mapFilterPermissionsService.canManage()"
        [matTooltip]="mapFilterPermissionsService.tooltipInsufficient() | transloco"
        [matTooltipDisabled]="mapFilterPermissionsService.canManage()"
        (click)="deleteClicked($event)">
        <fa-icon [icon]="['fas', 'trash']" />
    </button>
</li>
